import { useAccess } from '../../../lib/useAccess';
import { SectionHeader } from '../../../ui/PageHeader';
import { Section } from '../../../ui/Section';
import { ClientServicesRows } from '../../services/components/ClientServicesRows';
import { ClientAssetsSection } from './ClientAssetsSection';
import { ClientPoolSection } from './ServicePool';

/**
 * Zakładka „Utrzymanie” w profilu klienta (Figma 05: zakładki profilu; MODULE_UTRZYMANIE §5): umowy klienta
 * i wszystko, co stoi u nas na serwerze. Widok bez osobnego ekranu w Figmie (wzorce sekcji Przeglądu).
 * Na górze „Pula godzin” (17.10.2026): wykorzystanie puli aktywnych usług w bieżącym miesiącu (gdy klient ma pulę).
 * Bez modułu Utrzymanie: nic.
 */
export function ClientMaintenanceTab({ clientId }: { clientId: string }) {
  const access = useAccess();
  if (!access.can('maintenance')) return null;
  return (
    <div className="flex flex-col gap-4 md:gap-6">
      <ClientPoolSection clientId={clientId} />
      <Section aria-label="Umowy">
        <SectionHeader tone="strong" title="Umowy" />
        <ClientServicesRows clientId={clientId} showEmpty />
      </Section>
      <ClientAssetsSection clientId={clientId} />
    </div>
  );
}
